export function getSubdomain(): string {
  const host = window.location.hostname
  const parts = host.split(".")

  // Handle localhost (e.g. tenant1.localhost)
  if (host.endsWith("localhost") && parts.length === 2) {
    return parts[0]
  }

  // Handle production with real subdomains (e.g. tenant1.app.com)
  if (parts.length >= 3) {
    return parts[0] // 'tenant1'
  }

  // Optional: fallback to env or throw
  const fallback = import.meta.env.VITE_DEFAULT_TENANT || ""
  if (!fallback) {
    console.warn("⚠️ Tenant subdomain could not be resolved.")
  }
  return fallback
}

export function getTenantHost(): string {
  if (typeof window === "undefined") {
    return import.meta.env.VITE_DEFAULT_TENANT || ""
  }

  return window.location.hostname
}

// Admin portals are "admin-{company}.{domain}"; a company on the application
// domain itself, or on its own domain, uses "admin.{domain}".
export function isAdminPortal(): boolean {
  return /^admin[.-]/.test(getTenantHost())
}
